import { connect } from 'react-redux'
import CreateModal from './createModal';

export default connect()(CreateModal);
